import { WhatOurCustomersSayContent } from "./WhatOurCustomersRefactor";
import { LanguageContent } from "@components/Shared/model/LanguageContent";

export const WhatOurContentSays: LanguageContent<WhatOurCustomersSayContent> = {
	en: {
		title: "What Our Customers Say",
		navLabel: "Testimonials",
		videoId: "Jl-i1auVvmk",
		slides: [
			{
				person: "Caroline Robertson",
				personLabel: "",
				quote: `With ryerson.com I get the speed of the site with the support of the Ryerson sales team.`,
			},
			{
				person: "Kelly Singleton",
				personLabel: "",
				quote: `We sent out an RFP to two vendors. One provided a quote, but Ryerson provided a solution … it was a no brainer to go with Ryerson.`,
			},
			{
				person: "Larry Caschette",
				personLabel: "",
				quote: `We needed a partner to help us demonstrate that price is not all that matters. Ryerson has been there for us for decades.`,
			},
			{
				person: "Reggie Graham",
				personLabel: "",
				quote: `[Ryerson.com] has made ordering materials incredibly easy and efficient, which has really streamlined our process.`,
			},
		],
	},
	fr: {
		title: "Témoignages de nos clients",
		navLabel: "Témoignages",
		videoId: "Jl-i1auVvmk",
		slides: [
			{
				person: "Caroline Robertson",
				personLabel: "",
				quote: `Grâce à Ryerson.com, j’ai accès à la fois à la rapidité du site Web et au soutien de l’équipe de vente de Ryerson.`,
			},
			{
				person: "Kelly Singleton",
				personLabel: "",
				quote: `Nous avons envoyé une demande de propositions à deux fournisseurs. L’un d’eux nous a donné un devis, tandis que l’autre, Ryerson, nous a offert une solution. Il ne faisait aucun doute que Ryerson était le bon choix.`,
			},
			{
				person: "Larry Caschette",
				personLabel: "",
				quote: `Il nous fallait un partenaire pour nous aider à prouver que le prix n’est pas tout ce qui compte. Ryerson est là pour nous depuis des décennies.`,
			},
			{
				person: "Reggie Graham",
				personLabel: "",
				quote: `La commande de matériaux sur [Ryerson.com] est incroyablement simple et efficace, ce qui a permis de rationaliser nos processus.`,
			},
		],
	},
	es: {
		title: "Lo que dicen nuestros clientes",
		navLabel: "Testimonios",
		videoId: "Jl-i1auVvmk",
		slides: [
			{
				person: "Caroline Robertson",
				personLabel: "",
				quote: `Con ryerson.com recibo la velocidad del sitio web con el apoyo del equipo de ventas de Ryerson`,
			},
			{
				person: "Kelly Singleton",
				personLabel: "",
				quote: `Enviamos una RFP a dos proveedores. Uno nos proporcionó una cotización, pero Ryerson nos ofreció una solución… no había que pensarlo para elegir a Ryerson`,
			},
			{
				person: "Larry Caschette",
				personLabel: "",
				quote: `Necesitábamos un socio que nos ayudara a demostrar que el precio no es lo único que importa. Ryerson lleva décadas a nuestro lado`,
			},
			{
				person: "Reggie Graham",
				personLabel: "",
				quote: `Gracias a [Ryerson.com] hacer pedidos es increíblemente fácil y eficiente, lo cual nos ha ayudado a optimizar nuestros procesos.`,
			},
		],
	},
};
